import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import Select from 'modules/core/components/Select'
import TextField from 'modules/core/components/TextField'
import { FormErrors } from 'modules/core/hooks/useForm'
import countryList from 'modules/core/lib/countryList'
import i18n from 'modules/core/lib/i18n'

import { ResidenceValues } from '../ResidenceValues'

interface Props {
  values: ResidenceValues
  onChangeValue: (fieldName: string, fieldValue: string | undefined) => void
  readonly: boolean
  errors: FormErrors<ResidenceValues>
}

const ResidenceSection: React.FC<Props> = ({ values, onChangeValue, readonly, errors }) => {
  const optionalPlaceholder = i18n.t('common.optional')

  return (
    <Box gap="s24">
      <Box flexDirection="row" gap="s24">
        <TextField
          mandatory
          label={i18n.t('address_input.address_line_1')}
          value={values.addressLine1}
          readonly={readonly}
          onChange={(value) => onChangeValue('addressLine1', value)}
          error={errors.addressLine1}
        />
        <TextField
          label={i18n.t('address_input.address_line_2')}
          value={values.addressLine2}
          readonly={readonly}
          onChange={(value) => onChangeValue('addressLine2', value)}
          error={errors.addressLine2}
          placeholder={optionalPlaceholder}
        />
      </Box>
      <Box flexDirection="row" gap="s24">
        <TextField
          mandatory
          label={i18n.t('address_input.zip')}
          value={values.postalCode}
          readonly={readonly}
          onChange={(value) => onChangeValue('postalCode', value)}
          error={errors.postalCode}
        />
        <TextField
          mandatory
          label={i18n.t('address_input.city')}
          value={values.city}
          readonly={readonly}
          onChange={(value) => onChangeValue('city', value)}
          error={errors.city}
        />
        <TextField
          label={i18n.t('address_input.state')}
          value={values.state}
          readonly={readonly}
          onChange={(value) => onChangeValue('state', value)}
          error={errors.city}
        />
        <Select
          mandatory
          none={i18n.t('common.select')}
          readonly={readonly}
          onChange={(value) => onChangeValue('country', value)}
          label={i18n.t('address_input.country')}
          options={countryList}
          value={values.country}
          error={errors.country}
        />
      </Box>
    </Box>
  )
}

export default ResidenceSection
